import { section } from "@/glow";
import Carousel from "@/lib/carousel";
import { animateTestimonialsSlider, shouldAnimate } from "@/lib/animation";

const selectors = {
  swiperContainer: "[js-swiper]",
  nextButton: "[data-next]",
  prevButton: "[data-prev]",
};

const attrs = {
  blockIndex: "data-block-index",
  columnsTablet: "data-columns-tablet",
  columnsSmallDesktop: "data-columns-small-desktop",
  columnsDesktop: "data-columns-desktop",
  slidesCount: "data-slides-count",
};

section("testimonials-slider", {
  onLoad() {
    this._initCarousel();

    if (shouldAnimate(this.container)) {
      this.animateTestimonialsSlider = animateTestimonialsSlider(
        this.container
      );
    }
  },

  onBlockSelect({ target }) {
    const blockIndex = target.getAttribute(attrs.blockIndex);
    this.carousel?.slideTo(blockIndex);
  },

  _initCarousel() {
    const swiperContainer = this.container.querySelector(
      selectors.swiperContainer
    );

    const columnsTablet = parseInt(
      swiperContainer.getAttribute(attrs.columnsTablet),
      10
    );
    const columnsSmallDesktop = parseInt(
      swiperContainer.getAttribute(attrs.columnsSmallDesktop),
      10
    );
    const columnsDesktop = parseInt(
      swiperContainer.getAttribute(attrs.columnsDesktop),
      10
    );

    const slidesCount = parseInt(
      swiperContainer.getAttribute(attrs.slidesCount),
      10
    );

    const slidesPerViewMobile = 1.05;
    const slidesPerViewTablet = columnsTablet;
    const slidesPerViewSmallDesktop = columnsSmallDesktop;
    const slidesPerViewDesktop = columnsDesktop;

    this.carousel = Carousel(swiperContainer, {
      watchSlidesProgress: true,
      grabCursor: true,
      slidesPerView: slidesPerViewMobile,
      spaceBetween: 13, // matches product grid
      navigation: {
        nextEl: this.container.querySelector(selectors.nextButton),
        prevEl: this.container.querySelector(selectors.prevButton),
      },
      breakpoints: {
        720: {
          spaceBetween: 17, // matches product grid
          slidesPerView: slidesPerViewTablet,
        },
        960: {
          spaceBetween: 17, // matches product grid
          slidesPerView: slidesPerViewSmallDesktop,
        },
        1200: {
          spaceBetween: 25, // matches product grid
          slidesPerView: slidesPerViewDesktop,
        },
      },
      mousewheel: {
        forceToAxis: true,
      },
    });
  },

  onUnload() {
    this.carousel?.destroy();
    this.animateTestimonialsSlider?.destroy();
  },
});
